import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Vehicle } from '../models/Vehicle';

@Injectable({
  providedIn: 'root'
})
export class SelectedVehicleService {

  private _vehicle = new BehaviorSubject<Vehicle>(null);
  readonly vehicle = this._vehicle.asObservable();


  private _findYourIdealCardvehicle = new BehaviorSubject<Vehicle>(null);
  readonly findYourIdealCardvehicle = this._findYourIdealCardvehicle.asObservable();
  private dataStore: { vehicle:Vehicle,findYourIdealCardvehicle:Vehicle} = { vehicle:null,findYourIdealCardvehicle:null};

constructor() {
  let _cahcedVehicle = this.getCachedVehicle();
    if (_cahcedVehicle != null) {
      this.dataStore.vehicle = _cahcedVehicle;
      this._vehicle.next(Object.assign({}, this.dataStore).vehicle);
    }
 }

 updateVehicle(vehicle: Vehicle) {
  this.dataStore.vehicle = vehicle;
  this._vehicle.next(Object.assign({}, this.dataStore).vehicle);
  this.cachedVehicle(vehicle);

}
cachedVehicle(vehicle) {
  sessionStorage.setItem('selectedVehicle', JSON.stringify(vehicle));
}

getCachedVehicle() {
  return JSON.parse(sessionStorage.getItem('selectedVehicle'));
}

updateFindYourIdealCarVehicle(vehicle: Vehicle) {
  this.dataStore.findYourIdealCardvehicle = vehicle;
  this._findYourIdealCardvehicle.next(Object.assign({}, this.dataStore).findYourIdealCardvehicle);
  this.cachedVehicle(vehicle);

}


}
